var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-switch',{attrs:{"value":_vm.internalToggle},on:{"input":_vm.handleSwitchChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }